var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("折旧范围")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "swb-btn-link",
          on: {
            click: function($event) {
              _vm.selectDeprScope()
            }
          }
        },
        [_vm._v("选择")]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            ref: "multipleTable",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.deprScopeList,
              border: "",
              "tooltip-effect": "dark"
            }
          },
          [
            _c("el-table-column", { attrs: { prop: "name", label: "名称" } }),
            _vm._v(" "),
            _c("el-table-column", { attrs: { prop: "type", label: "类型" } })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9f5daad0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f5daad0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/AssetDeprComp.vue
// module id = 3098
// module chunks = 0